/* eslint-disable import/no-default-export */
import { mallEntranceDomain } from '@/defines/domains'
import { request } from '../request'

export const mallEntranceApi = {
  async post(path, data) {
    try {
      const url = `${mallEntranceDomain}${path}`
      const res = await request(url, data)
      if (res.ret) {
        return res.data
      } else {
        return Promise.reject(res)
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
